import ActionTypes from '../action-types';

const initialState = { isAuthenticated: false };

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ActionTypes.SESSION_OFF:
      return {
        ...state,
        isAuthenticated: false
      };

    case ActionTypes.SESSION_ON:
      return {
        ...state,
        isAuthenticated: true
      };

    default:
      return state;
  }
};
